import { PolicyHandleSource } from '@/dashboard/types/PolicyTypes';
import qs from 'qs';

export const Routes = {
  policies: (querys?: { queryUserId?: string }) => `/${!!querys ? '?' + qs.stringify(querys) : ''}`,
  documents: () => '/documents',
};

export const getHomePolicysPath = () => {
  return '/';
};
export const getRenewPolicyPath = (policyId, query?: Record<string, any>) => {
  if (!policyId) return '';
  return `/policy/renew/${policyId}${!!query ? `?${qs.stringify(query)}` : ''}`;
};
export const getRenewPolicyDeclarationPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/renew/${policyId}/declarations`;
};
export const getRenewPolicyConfirmPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/renew/${policyId}/confirm`;
};
export const getBusinessTypePath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/business-type`;
};
export const getBusinessActivitiesPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/business-activities`;
};
export const getCompanyNameAndAddressPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/company-name-address`;
};
export const getEstimatedIncomePath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/estimated-income`;
};
export const getIncomeSplitPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/income-split`;
};
export const getCoversPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/covers`;
};
export const getErnPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/ern`;
};
export const getEmployeesPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/employees`;
};
export const getContractPeroidPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/contract-period`;
};
export const getClientNamePath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/client-name`;
};
export const getContractIncomePath = (policyId) => {
  if (!policyId) return '';
  return `/policy/info/${policyId}/contract-income`;
};
export const getUpdatePolicyPath = (policyId, query?: Record<string, any>) => {
  if (!policyId) return '';
  return `/policy/update/${policyId}${!!query ? `?${qs.stringify(query)}` : ''}`;
};
export const getUpdatePolicyConfirmPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/update/${policyId}/confirm`;
};
export const getSwitchToAnnualPolicyPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/switch-annual/${policyId}`;
};
export const getSwitchToAnnualPolicyConfirmPath = (policyId) => {
  if (!policyId) return '';
  return `/policy/switch-annual/${policyId}/confirm`;
};
export const getSettingIndexPath = () => {
  return `/setting`;
};
export const getSettingGeneralPath = () => {
  return `/setting/general`;
};
export const getSettingPasswordPath = () => {
  return `/setting/password`;
};
export const getSettingPaymentDetailsPath = () => {
  return `/setting/payment-details`;
};
export const getSettingNotificationsPath = () => {
  return `/setting/notifications`;
};
export const getDeleteAccountPath = () => {
  return `/setting/delete-account`;
};
export const getSettingAddNewCardPath = () => {
  return `/setting/add-payment-card`;
};
export const getHomeDocumentsPath = () => {
  return '/documents';
};

export const getSignaturePath = (config: { policyId: string; quoteId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/sign/${config?.policyId}?${qs.stringify(params)}`;
};

export const getConfirmQuotePricePath = (config: { policyId: string; quoteId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/confirm/${config?.policyId}/price?${qs.stringify(params)}`;
};

export const getConfirmSuccessPath = (config: { policyId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/success/${config?.policyId}?${qs.stringify(params)}`;
};

export const getPolicyRefferPath = (config: { policyId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/reffer/${config?.policyId}?${qs.stringify(params)}`;
};

export const getPolicyDraftSuccessPath = (config: { policyId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/success/${config?.policyId}/draft?${qs.stringify(params)}`;
};

export const getPolicyReferralSuccessPath = (config: { policyId: string; detailSource: PolicyHandleSource }) => {
  const params = { ...config };
  delete params.policyId;
  return `/policy/success/${config?.policyId}/referral?${qs.stringify(params)}`;
};
